import type { FindHyperguestHotelsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useHyperguestProductHotels = (input: FindHyperguestHotelsInput) =>
  trpc.hyperguestHotels.findProducts.useQuery(input, {
    placeholderData: keepPreviousData,
  });
